var map = {
	"./arm-recoil-1.png": 22413,
	"./arm-recoil-2.png": 90646,
	"./arm-recoil-3.png": 44447,
	"./arm-recoil-4.png": 16416,
	"./arm-recoil-5.png": 40617,
	"./heel-to-ear-1.png": 5106,
	"./heel-to-ear-2.png": 54894,
	"./heel-to-ear-3.png": 54391,
	"./heel-to-ear-4.png": 32248,
	"./heel-to-ear-5.png": 53377,
	"./heel-to-ear-6.png": 12298,
	"./lung-anterior-default.png": 67337,
	"./lung-anterior-upper-left.png": 62546,
	"./lung-anterior-upper-right.png": 59087,
	"./lung-lateral-left-default.png": 43300,
	"./lung-lateral-left.png": 67676,
	"./lung-lateral-right-default.png": 95709,
	"./lung-lateral-right.png": 72473,
	"./lung-posterior-default.png": 77478,
	"./lung-posterior-left-lower.png": 47122,
	"./lung-posterior-left-upper.png": 26165,
	"./lung-posterior-right-lower.png": 40871,
	"./lung-posterior-right-upper.png": 43544,
	"./pain-rating-scale-1.png": 66093,
	"./pain-rating-scale-2.png": 59062,
	"./pain-rating-scale-3.png": 37151,
	"./pain-rating-scale-4.png": 78496,
	"./pain-rating-scale-5.png": 33321,
	"./pain-rating-scale-6.png": 68178,
	"./popliteal-angle-1.png": 5230,
	"./popliteal-angle-2.png": 24005,
	"./popliteal-angle-3.png": 6492,
	"./popliteal-angle-4.png": 90099,
	"./popliteal-angle-5.png": 39338,
	"./popliteal-angle-6.png": 88321,
	"./popliteal-angle-7.png": 15608,
	"./posture-1.png": 50738,
	"./posture-2.png": 41449,
	"./posture-3.png": 86624,
	"./posture-4.png": 37951,
	"./posture-5.png": 41622,
	"./pulse-carotid-left.png": 56228,
	"./pulse-carotid-right.png": 85505,
	"./pulse-default.png": 95947,
	"./pulse-peripheral-left-brachial.png": 26135,
	"./pulse-peripheral-left-dorsalis-pedis.png": 83848,
	"./pulse-peripheral-left-femoral.png": 86881,
	"./pulse-peripheral-left-popliteal.png": 77647,
	"./pulse-peripheral-left-posterior-tibial.png": 8216,
	"./pulse-peripheral-left-radial.png": 92876,
	"./pulse-peripheral-right-brachial.png": 63524,
	"./pulse-peripheral-right-dorsalis-pedis.png": 1083,
	"./pulse-peripheral-right-femoral.png": 6360,
	"./pulse-peripheral-right-popliteal.png": 86482,
	"./pulse-peripheral-right-posterior-tibial.png": 48867,
	"./pulse-peripheral-right-radial.png": 72071,
	"./scarf-sign-1.png": 19203,
	"./scarf-sign-2.png": 82344,
	"./scarf-sign-3.png": 92561,
	"./scarf-sign-4.png": 9470,
	"./scarf-sign-5.png": 61959,
	"./scarf-sign-6.png": 59308,
	"./square-window-1.png": 63276,
	"./square-window-2.png": 83335,
	"./square-window-3.png": 65022,
	"./square-window-4.png": 6033,
	"./square-window-5.png": 91816,
	"./square-window-6.png": 93443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69636;